<template>
  <div>
    <header>
      <img
        v-if="showFlagGoTopBtn"
        class="go-top"
        src="./imgs/back-top-h.png"
        @click="backTop"
      />
      <div
        :class="
          sitename == 'eduyun' || sitename == 'researcher'
            ? 'topBarWrap'
            : 'topBarWrapBlue'
        "
      >
        <div class="topBar">
          <div class="topBar_left">
            <a
              href="javascript:;"
              @click="gotoEduCitySpace()"
              v-if="websiteSessionInfo.webSiteCityName != ''"
              >{{ websiteSessionInfo.webSiteCityName }}</a
            >
            <a
              href="javascript:;"
              @click="gotoEduCountySpace()"
              v-if="websiteSessionInfo.webSiteCountyName != ''"
              >{{ websiteSessionInfo.webSiteCountyName }}</a
            >
            <a
              href="javascript:;"
              @click="gotoSchoolSpace()"
              v-if="websiteSessionInfo.webSiteSchoolName != ''"
              >{{ websiteSessionInfo.webSiteSchoolName }}</a
            >
          </div>

          <div class="topBar_right" v-if="websiteSessionInfo.logined">
            <div></div>
            <el-dropdown>
              <span class="el-dropdown-link">
                <a class="user">
                  <img
                    :src="websiteSessionInfo.userFace"
                    :onerror="errorFaceImg"
                  />
                </a>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="jumpToMyMessages()">
                  <a style="color: #333"
                    >我的消息<i class="msg" v-if="has_unread_msg"></i
                  ></a>
                </el-dropdown-item>
                <el-dropdown-item @click.native="jumpToMySpace(1)">
                  <a style="color: #333">我的空间</a>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    websiteSessionInfo.userSchoolID > 0 &&
                    websiteSessionInfo.userIdentityStatus == 1
                  "
                  @click.native="jumpToMySpace(2)"
                >
                  <a style="color: #333">我的班级</a>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="
                    websiteSessionInfo.userSchoolID > 0 &&
                    websiteSessionInfo.userIdentityStatus == 1
                  "
                  @click.native="jumpToMySpace(3)"
                >
                  <a style="color: #333">我的学校</a>
                </el-dropdown-item>

                <el-dropdown-item
                  v-for="item in websiteSessionInfo.userAdminList"
                  @click.native="jumpToAdmin(item.url)"
                  :key="item.organization_id"
                >
                  <a style="color: #333">{{ item.name }}</a>
                </el-dropdown-item>

                <el-dropdown-item>
                  <a href="rizhaojiaoyuPC://" style="color: #333">打开客户端</a>
                </el-dropdown-item>
                <el-dropdown-item @click.native="loginOut">
                  <a class="exit" style="color: #333">退出</a>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="username">{{ websiteSessionInfo.userName }}</span>
            <!-- <a href="JavaScript:;">消息</a> -->
          </div>
          <div class="topBar_right" v-if="!websiteSessionInfo.logined">
            <a @click="toLoginPage">登录</a>
            <a @click="toRegisterPage">注册</a>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { WebSiteName } from "../webname.js";
import router from "../router";
import globalApi from "./globalApi.js";

export default {
  name: "top",
  data() {
    return {
      errorFaceImg: "",
      showFlagGoTopBtn: false, //是否显示返回顶部的按钮： 教育云首页和学校首页有自己的返回顶部按钮，不需要单独显示
      websiteSessionInfo: globalApi.gWebsiteSessionInfo,
      sitename: WebSiteName,
      msg_count: 0,
      has_unread_msg: false,
    };
  },

  components: {},

  computed: {
    globalVaranthasInited() {
      return globalApi.gWebsiteSessionInfo.hasInited;
    },
  },
  watch: {
    $route() {
      //监控$route
      document.documentElement.scrollTop = 0;
      this.UpdateWebPageInfo(true);
    },
    globalVaranthasInited: function (val, oldval) {
      console.log(
        "top watch.hasInited globalVaranthasInited val=" +
          val +
          "  oldval=" +
          oldval
      );
      console.log(this);
      this.init();
    },
  },

  created() {
    document.documentElement.scrollTop = 0;
    //从服务器上域名站点信息和登录信息，必须首先调用，且不能使用异步
    //let success = globalApi.GetWebInfoAndUserSessionInfoFromServer();
    //console.log(" globalApi.GetWebInfoAndUserSessionInfoFromServer result" + ":" + success);
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  methods: {
    init() {
      //师生展评和文章详情必须登录
      if (globalApi.gWebsiteSessionInfo.webSiteNeedLogin){
        if (
          (WebSiteName == "article" || WebSiteName == "zhanping") &&
          !globalApi.gWebsiteSessionInfo.logined
        ) {
            localStorage.setItem("objectPath", location.href);
            this.$message.error("您没有登录，请先登录！");

            let fromurl = encodeURIComponent(location.href);
            location.href = globalApi.GetWebHost("login") + '?fromurl=' + fromurl;

            return;
        }
      }
      if (globalApi.gUserIdentity == 1) {
        this.errorFaceImg =
          'this.src="' + require("./imgs/default-student.png") + '"'; // 学生图片损坏默认图
      } else {
        this.errorFaceImg =
          'this.src="' + require("./imgs/default-teacher.png") + '"'; // 图片损坏默认图
      }
      this.UpdateWebPageInfo(false);
      if (globalApi.IsLogIned()) {
        this.getReceivedMessageCount();
      }
    },
    //获取 title ，主站连接信息
    async UpdateWebPageInfo(getfromsvr) {
      let success = true;
      if (getfromsvr) {
        success = await globalApi.GetWebInfoAndUserSessionInfoFromServer(false);
      }
      if (this.websiteSessionInfo.webSiteDocumentTitle != "") {
        document.title = this.websiteSessionInfo.webSiteDocumentTitle;
      }
      //logo
      if (this.websiteSessionInfo.webSiteLogo != "") {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = this.websiteSessionInfo.webSiteLogo;
        document.getElementsByTagName("head")[0].appendChild(link);
      }

      //style
      // 拿到style名称，拼接需要引入的css文件名
      //var src = '/' + 'style2' + '/css/edu.css';
      //var link = $('<link>');  // 生成link标签
      //link.prop('rel', 'stylesheet');  // 设置link的rel属性
      //link.prop('href', src);  // 设置link的href属性
      //$('head').append(link);  // 将link标签添加到head标签中
    },

    //跳转到管理后台
    async jumpToUrl(url) {
      const logined = await globalApi.CheckLoginUserStatus();
      if (!logined) {
        this.$confirm(
          "当前登录已过期，请重新登录", //可能原因：<br/>1：登录超时.<br/>2：您的账号在其他地方登陆.<br/>如需修改密码，请使用终端进行操作。
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            dangerouslyUseHTMLString: true,
          }
        )
          .then(() => {
            this.toLoginPage();
          })
          .catch(() => {
            this.toLoginPage();
          });
        return;
      }
      window.open(url);
    },

    async jumpToAdmin(url) {
      //将url 替换成本域名下的url
      let arr_host = location.host.split(".");
      let subsite = arr_host[0];
      var myURL = new URL(url);
      let arr_url_host = myURL.host.split(".");

      if (globalApi.useSubSiteHost) {
        if (globalApi.gAllWebSubSite.indexOf(subsite) >= 0) {
          arr_host[0] = arr_url_host[0]; //替换成 edu-admin 或 school-admin
          myURL.host = arr_host.join(".");
        } else {
          myURL.host = arr_url_host[0] + "." + location.host;
        }
      }

      let newurl = myURL.href;
      this.jumpToUrl(newurl);
    },

    // 跳转到登录页
    toLoginPage() {
      localStorage.setItem("objectPath", location.href);
      
      let fromurl = encodeURIComponent(location.href);
      location.href = globalApi.GetWebHost("login") + '?fromurl=' + fromurl;
            
    },
    // 跳转到注册
    toRegisterPage() {
      localStorage.setItem("objectPath", location.href);
      location.href = globalApi.GetWebHost("reg") + "register";
    },
    // 退出登录
    async loginOut() {
      localStorage.setItem("objectPath", location.href);
      globalApi.loginOut();
      this.$router.go(0);
    },

    //我的消息
    //获取消息列表
    async getReceivedMessageCount() {
      let data = {
        s: "Common.UserMsgBox.getReceivedMessageCount",
        operatorid: this.websiteSessionInfo.userid,
        schoolid: 1,
      };
      let res = await globalApi.post(data);
      if (res.data.ret == 200 && res.data.data.result == 1) {
        this.msg_count = res.data.data.count;
        this.has_unread_msg = this.msg_count > 0;
      }
    },
    jumpToMyMessages() {
      const urls =
        globalApi.GetWebHost("article") +
        "messages?userid=" +
        this.websiteSessionInfo.userid;
      this.jumpToUrl(urls);
    },
    // 跳转页面
    // 1 我的空间(教师/学生空间)
    // 2 我的班级
    // 3 我的学校
    jumpToMySpace(val) {
      let url = "";
      if (val == 1) {
        if (this.websiteSessionInfo.userIdentity == 1) {
          url = globalApi.getStudentSpaceUrl(this.websiteSessionInfo.userid);
        } else if (this.websiteSessionInfo.userIdentity == 4) {
          //教研员空间优先
          url = globalApi.getResearcherSpaceUrl(this.websiteSessionInfo.userid);
        } else if (this.websiteSessionInfo.userIdentity == 2) {
          //教研员空间优先
          url = globalApi.getTeacherSpaceUrl(this.websiteSessionInfo.userid);
        } else {
          alert("您的个人空间尚未开通");
          return;
        }
      } else if (val == 2) {
        if (this.websiteSessionInfo.userSchoolClassID > 0) {
          url = globalApi.getSchoolClassSpaceUrl(
            this.websiteSessionInfo.userSchoolClassID
          );
        } else {
          url =
            globalApi.GetWebHost("teacher") +
            "my_class?userid=" +
            this.websiteSessionInfo.userid;
        }
      } else if (val == 3) {
        url = globalApi.getSchoolSpaceUrl(this.websiteSessionInfo.userSchoolID);
      }
      if (url != "") {
        this.jumpToUrl(url);
      }
    },

    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },

    // 为了计算距离顶部的高度，当高度大于500显示回顶部图标，小于500则隐藏
    scrollToTop() {
      const that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      if (that.scrollTop > 500) {
        that.showFlagGoTopBtn =
          WebSiteName != "eduyun" && WebSiteName != "school";
      } else {
        that.showFlagGoTopBtn = false;
      }
    },

    // 跳转到主站
    gotoEduCitySpace() {
      let url = globalApi.getEduYunSpaceUrl(
        this.websiteSessionInfo.webSiteCityEduID
      );
      window.open(url);
    },
    gotoEduCountySpace() {
      let url = globalApi.getCountyEduYunSpaceUrl(
        this.websiteSessionInfo.webSiteCountyEduID
      );
      window.open(url);
    },
    gotoSchoolSpace() {
      let url = globalApi.getSchoolSpaceUrl(
        this.websiteSessionInfo.webSiteSchoolID
      );
      window.open(url);
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
};
</script>

<style lang="scss">
header {
  .topBarWrap {
    color: #333333;
    a {
      color: #5d5e63;
    }
    font-size: 14px;
    background: #f4f4f4;
    line-height: 35px;
    border-bottom: 1px solid #c0c0c0;
    .topBar {
      background: #f4f4f4;
      width: 1200px;
      height: 35px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      a {
        margin-right: 20px;
      }
      .topBar_right {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-dropdown-item {
          a {
            color: #333 !important;
          }
        }
        img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          vertical-align: middle;
        }
        .el-dropdown-link {
          cursor: pointer;
          color: #fff;
        }
        .el-icon-arrow-down {
          font-size: 12px;
        }
        .item {
          margin-top: 10px;
          margin-right: 40px;
        }
      }
    }
  }
  .topBarWrapBlue {
    color: #fff;
    a {
      color: #fff;
    }
    font-size: 14px;
    background: #0077b3;
    line-height: 40px;
    .topBar {
      background: #0077b3;
      width: 1200px;
      height: 40px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      a {
        margin-right: 20px;
      }
      .topBar_right {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-dropdown-item {
          a {
            color: #333 !important;
          }
        }
        img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          vertical-align: middle;
        }
        .el-dropdown-link {
          cursor: pointer;
          color: #fff;
        }
        .el-icon-arrow-down {
          font-size: 12px;
        }
        .item {
          margin-top: 10px;
          margin-right: 40px;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.username {
  display: inline-block;
  margin: 0 10px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 5em;
}
// .user_dropdown_item {
//   padding: 0;
//   a {
//     padding: 0 10px;
//     display: inline-block;
//   }
// }
.go-top {
  position: fixed;
  right: 60px;
  bottom: 60px;
  width: 100px;
  height: 100px;
  width: 60px;
  height: 60px;
}
</style>
<style lang="scss" scoped>
.el-dropdown-menu__item {
  width: auto !important;
  a {
    display: block;
  }
}
.el-dropdown-menu {
  width: auto !important;
}
.msg {
  position: absolute;
  display: block;
  border-radius: 50%;
  background-color: #ff2122;
  color: #fff;
  font-size: 0.3rem;
  width: 0.6rem;
  height: 0.6rem;
  line-height: 0.4rem;

  top: 0.9rem;
  right: 0.6rem;
}
</style>